import { render } from "./Navbar.vue?vue&type=template&id=be53b9fe&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=be53b9fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-be53b9fe"

export default script